import Helpers from '../base/Helpers';
import Environment from '../resources/Environment';

export default class Settings {
	/**
	 * Merchant API auth key
	 */
	auth_key?: string = undefined;

	/**
	 * Merchant API auth hash (MD5 of secret key)
	 */
	auth_hash?: string = undefined;

	/**
	 * Merchant API platform auth user (SHA-512 of user email)
	 */
	auth_user?: string = undefined;

	/**
	 * Merchant API endpoint URL
	 */
	endpoint?: string = undefined;

	/**
	 * Merchant API environment
	 */
	environment?: string = undefined;

	/**
	 * Settings response messages language
	 */
	lang?: string = undefined;

	/**
	 * SDK identifier
	 */
	sdk?: string = undefined;

	/**
	 * SDK identifier
	 */
	sdk_version?: string = undefined;

	/**
	 * Request headers
	 */
	headers?: Record<string, any> = undefined;

	/**
	 * Public encryption key
	 */
	public_key?: string | null = undefined;

	/**
	 * Initialize service
	 */
	constructor() {
		this.endpoint = 'https://pixelpay.app';
	}

	/**
	 * Setup API endpoint URL
	 *
	 * @param endpoint
	 */
	setupEndpoint(endpoint: string) {
		this.endpoint = endpoint;
	}

	/**
	 * Setup API credentials
	 *
	 * @param key
	 * @param hash
	 */
	setupCredentials(key: string, hash: string) {
		this.auth_key = key;
		this.auth_hash = hash;
	}

	/**
	 * Setup API platform user
	 *
	 * @param hash
	 */
	setupPlatformUser(hash: string) {
		this.auth_user = hash;
	}

	/**
	 * Setup API environment
	 *
	 * @param env
	 */
	setupEnvironment(env: string) {
		this.environment = env;
	}

	/**
	 * Setup defaults to Sandbox credentials
	 */
	setupSandbox() {
		this.endpoint = 'https://pixelpay.dev';
		this.auth_key = '1234567890';
		this.auth_hash = Helpers.hash('MD5', '@s4ndb0x-abcd-1234-n1l4-p1x3l');
		this.environment = Environment.SANDBOX;
	}

	/**
	 * Setup response messages language
	 *
	 * @param lang
	 */
	setupLanguage(lang?: string) {
		this.lang = lang;
	}

	/**
	 * Setup request headers
	 *
	 * @param headers
	 */
	setupHeaders(headers: Record<string, any>) {
		this.headers = headers;
	}
}
